import { render, staticRenderFns } from "./HistoryDetailModal.vue?vue&type=template&id=d2a06982&"
import script from "./HistoryDetailModal.vue?vue&type=script&lang=js&"
export * from "./HistoryDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./HistoryDetailModal.vue?vue&type=style&index=0&id=d2a06982&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports